import { useEffect,useState } from 'react'
import { listen } from 'utils/message'

export default function useReflowFrameClassName() {
  const [reflowFrameCX, setReflowFrameCX] = useState('')

  useEffect(() => {
    listen({
      topic: 'CONDUCTOR:reflowFrame',
      handler: ({ data }) => {
        setReflowFrameCX(() => {
          return data.isXSScreenSize ? 'widget--xs' : ''
        })
      }
    })
  }, [])

  return reflowFrameCX
}
